module.exports = __webpack_public_path__ + "static/media/js.09ab766a.svg";